import { useState } from "react";

const submitAddr = "https://readdy.ai/api/form/da28r2rk8r5te5mqsjng";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = (fd.get("phone_alt") as string) || "";
    const email = (fd.get("email") as string) || "";
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setFormError("请输入有效的邮箱地址。");
      return;
    }

    if (honeypot.trim() !== "") {
      setStatus("success");
      return;
    }

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code as string | undefined;
      const message =
        (parsed?.meta as { message?: string } | undefined)?.message ||
        (parsed?.message as string | undefined) ||
        (parsed?.meta as { detail?: string } | undefined)?.detail ||
        "";
      const lower = `${code} ${message}`.toLowerCase();

      if (res.ok && code === "OK" && !lower.includes("spam")) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(message || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="contact" className="section-pad relative overflow-hidden bg-background-100/60">
      <div className="container-site grid gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="text-xs font-medium uppercase tracking-widest text-accent-600">Stay Updated</span>
          <h2 className="mt-1 font-heading text-3xl md:text-4xl">订阅更新，好番第一时间知道</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            留下邮箱，我们会把最新上架、续播更新与精选合集通知发给你，让你永远抢先一步开刷。
          </p>

          <div className="mt-6 flex flex-col gap-3 text-sm text-foreground-700">
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-mail-line text-xl" />
              </span>
              <span>联系邮箱：hello@mantu-anime.com</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-message-3-line text-xl" />
              </span>
              <span>追番咨询：欢迎随时来信，我们乐于推荐好番</span>
            </div>
          </div>
        </div>

        <div className="rounded-3xl border border-background-200 bg-background-50 p-6 card-shadow md:p-8">
          <h3 className="font-heading text-xl text-foreground-950">订阅追番通知</h3>
          <p className="mt-1 text-xs text-foreground-500">免费订阅，随时可退订，绝无广告打扰。</p>

          <form data-readdy-form onSubmit={handleSubmit} className="mt-5 flex flex-col gap-4" noValidate>
            <label className="flex flex-col gap-1.5">
              <span className="text-sm font-medium text-foreground-800">常用邮箱</span>
              <input
                type="email"
                name="email"
                required
                placeholder="name@example.com"
                className="h-12 rounded-xl border border-background-200 bg-background-100 px-4 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:bg-background-50 placeholder:text-foreground-400"
              />
            </label>

            <label className="flex flex-col gap-1.5">
              <span className="text-sm font-medium text-foreground-800">常看的动漫类型</span>
              <select
                name="preference"
                className="h-12 rounded-xl border border-background-200 bg-background-100 px-4 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:bg-background-50"
              >
                <option value="">请选择偏好（选填）</option>
                <option>热血战斗</option>
                <option>恋爱治愈</option>
                <option>奇幻冒险</option>
                <option>科幻机甲</option>
                <option>搞笑日常</option>
                <option>其他类型</option>
              </select>
            </label>

            {/* 反垃圾蜜罐字段 */}
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />

            {status === "error" && formError && (
              <p className="rounded-lg bg-primary-100 px-3 py-2 text-xs text-primary-700" role="alert">
                <i className="ri-error-warning-line mr-1" />
                {formError}
              </p>
            )}
            {status === "success" && (
              <p className="rounded-lg bg-accent-100 px-3 py-2 text-xs text-accent-700" role="status">
                <i className="ri-checkbox-circle-line mr-1" />
                订阅成功！我们会第一时间把好番更新通知发到你的邮箱。
              </p>
            )}

            <button
              type="submit"
              disabled={status === "loading"}
              className="flex h-12 items-center justify-center gap-1.5 whitespace-nowrap rounded-xl bg-primary-500 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {status === "loading" ? (
                <>
                  <i className="ri-loader-4-line animate-spin" />
                  提交中…
                </>
              ) : (
                <>
                  <i className="ri-mail-send-line" />
                  立即订阅
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}